import React, { type ReactElement } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import { theme } from '../../../theme/theme';

interface MyProfileTabsProps {
  tabs: { label: string; children: ReactElement; activeIcon: ReactElement; inactiveIcon: ReactElement }[];
  activeTab: number;
  onChange: (_index: number) => void;
}

export default function MyProfileTabs({ tabs, activeTab, onChange }: MyProfileTabsProps): ReactElement {
  return (
    <Box
      position="fixed"
      display="flex"
      width="100vw"
      flexDirection="column"
      height="100vh"
      paddingBottom={6}
      overflow="auto"
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid #DCE0E5"
        padding="0 16px"
      >
        <Tabs
          orientation="horizontal"
          value={activeTab}
          onChange={(_, newValue) => onChange(newValue)}
          sx={{ alignItems: 'flex-start' }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={tab.label}
              label={
                <Box display="flex" alignItems="center">
                  {activeTab === index ? tab.activeIcon : tab.inactiveIcon}
                  <Typography
                    variant="tableRowRegular"
                    sx={{
                      marginLeft: 1,
                      color: activeTab === index ? `${theme.palette.shades.lightBlueColor}` : 'text.secondary',
                    }}
                  >
                    {tab.label}
                  </Typography>
                </Box>
              }
              sx={{
                fontWeight: 'normal',
                textTransform: 'none',
              }}
            />
          ))}
        </Tabs>
      </Box>

      <Box flexGrow={1} overflow="auto" padding={2} display="flex" justifyContent="center" alignItems="flex-start">
        {tabs[activeTab]?.children}
      </Box>
    </Box>
  );
}
